

















































































































import LocationProfileDto from '@/models/Locations/LocationProfileDto'
import { Component, Vue } from 'vue-property-decorator'
import { LocationListModule } from '@/store/modules/locationList';
import PageNames from '@/router/PageNames';
import LocationSearchCriteria from '@/components/Locations/LocationListSearchCriteria.vue';
import LocationListEmail from '@/components/Locations/LocationListEmail.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import AddressUtils from '@/lib/addressUtils';
import { LocationDetailsModule } from '@/store/modules/locationDetails';
import Alert from '@/components/Shared/Alert.vue';

@Component({
  name: 'LocationList',
  components: {
    Alert,
    LocationSearchCriteria,
    LocationListEmail,
  }
})
export default class extends GiganautVue {

  locationInfoWindowPos: any = null;
  locationInfoWinOpen = false;
  currentLocationIndex: any = null;
  locationInfoOptions: any = {
    content: '',
      //optional: offset infowindow so it visually sits nicely on top of our marker
      pixelOffset: {
        width: 0,
        height: -35
      }
  };

  workerInfoWindowPos: any = null;
  workerInfoWinOpen = false;
  workerInfoOptions: any = {
    content: '',
      //optional: offset infowindow so it visually sits nicely on top of our marker
      pixelOffset: {
        width: 0,
        height: -35
      }
  };

  async navigateToLocation(item: LocationProfileDto) {
    const locationId = item.id;
    this.$router.push({ name: PageNames.AgencyLocationDetails, params: { locationid: locationId } });
  }

  get locations(): LocationProfileDto[] {
    return LocationListModule.locations;
  }

  get loading() {
    return LocationListModule.loading;
  }

  get searchOptions() {
    return LocationListModule.locationSearchViewModel;
  }

  created() {
    this.getLocations();
  }

  private getLocations() {
    LocationListModule.searchLocations();
  }

  get getRadius() {
    return Math.abs((LocationListModule.locationSearchViewModel.selectedDistance.value * 1609));
  }

  get isProximitySearch() {
    return LocationListModule.locationSearchViewModel.selectedWorker != null;
  }

  get locationLatLng() {
    if (this.isProximitySearch) {
      return {lng:LocationListModule.locationSearchViewModel.selectedWorker.longitude,lat:LocationListModule.locationSearchViewModel.selectedWorker.latitude}
    }
    return null;
  }

  async toggleLocationInfoWindow(location: any, idx: any) {

    this.locationInfoWindowPos = {lng:location.longitude,lat:location.latitude}
    this.locationInfoOptions.content = "<p class='body-2'>" + location.brandName + "</p><p>" + AddressUtils.fullAddressLine(location) + "</p><p><a href='" + window.location.origin + "/agency/locations/" + location.id + "' target='_blank'>Open in new tab</a>";

    //check if its the same marker that was selected if yes toggle
    if (this.currentLocationIndex == idx) {
      this.locationInfoWinOpen = !this.locationInfoWinOpen;
    }
    //if different marker set infowindow to open and reset current marker index
    else {
      this.locationInfoWinOpen = true;
      this.currentLocationIndex = idx;
    }
  }

  async toggleWorkerInfoWindow() {
    const selectedWorker = LocationListModule.locationSearchViewModel.selectedWorker;
    if (selectedWorker !== null) {
    this.workerInfoWindowPos = {lng:selectedWorker.longitude,lat:selectedWorker.latitude}
    this.workerInfoOptions.content = "<p class='body-2'>" + selectedWorker.fullName + "</p><p>" + AddressUtils.fullAddressLine(selectedWorker) + "</p><p><a href='" + window.location.origin + "/agency/workers/" + selectedWorker.id + "' target='_blank'>Open in new tab</a>";

    //check if its the same marker that was selected if yes toggle
    this.workerInfoWinOpen = !this.workerInfoWinOpen;
    }
  }

  private search = '';
  
  private headers = [
    // { text: '', value: 'avatar' },
    { text: 'Ref', value: 'sequenceNumber' },
    { text: 'Brand Name', value: 'brandName' },
    { text: 'Email Address'},
    { text: 'Phone Number'},    
    { text: 'Type', value: 'locationTypeName' },
    { text: 'Actions' },
  ]
}
